import { Component, OnInit, ViewChild } from "@angular/core";
import columnHeader from "../../components/data-grid/model/ColumnHeader";
import { PaginationComponent } from "../../components/pagination/pagination.component";
import { Router } from "@angular/router";
import { CuentasService } from "../../services/cuentas.service";
import { PaletaService } from "../../services/paleta.service";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { formatNumber } from "@angular/common";
import { getMonth } from "src/app/helpers/basicFunctions";
import { ReportesService } from "src/app/services/reportes.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-operaciones-extinguidas",
  templateUrl: "./operaciones-extinguidas.component.html",
  styleUrls: ["./operaciones-extinguidas.component.scss"],
})
export class OperacionesExtinguidasComponent implements OnInit {
  fechaISO: any = "";
  isDataLoaded: boolean = false;
  showModalExtinguir: boolean = false;
  showModalAnular: boolean = false;
  headersNegociacion: columnHeader[] = [];
  dataNegociacion: any[] = [];
  listaPaletaGestion: any = [];
  paginationNegociacion: any = {
    hasNextPage: false,
    hasPrevPage: false,
    totalPages: [],
    page: 0,
  };
  baseApi: any = environment.baseApi;

  @ViewChild("paginationNegociacion", { static: false })
  paginadorNegociacion: PaginationComponent;

  constructor(
    private route: Router,
    private cuentasService: CuentasService,
    private paletaService: PaletaService,
    private reportesService: ReportesService
  ) //private socket: Socket
  {
    let a: any = new Date();
    this.fechaISO = a.toDateString().split(" ");
    /*this.socket.on('connect', () => {
        console.log('Conectado a servidor socket')
      });*/

    /*this.socket.emit("enviar-mensaje","PRueba mensaje")

      this.socket.on('enviar-mensaje', (arg) => {
        console.log(arg);
      });*/

    //const socket:any = io("http://localhost:3000");
  }

  ngOnInit() {
    this.paletaService.getPaleta().subscribe((data: any) => {
      let paletaTemp: any = [];
      for (let paleta of data.paletas) {
        for (let resultado of paleta.resultado_gestion) {
          paletaTemp.push({
            id: resultado.id,
            resultado_: paleta._id + "-" + resultado.resultado_gestion,
          });
        }
      }
      this.listaPaletaGestion = paletaTemp;
    });
    this.headersNegociacion = [
      {
        label: "Nro Documento",
        key: "nro_documento",
        subKey: "",
        customClass: "",
        type: "",
      },
      {
        label: "Cliente",
        key: "clientes",
        subKey: "nombre",
        customClass: "",
        type: "cliente",
      },
      {
        label: "Cartera",
        key: "asignacion",
        subKey: "",
        customClass: "",
        type: "cartera",
      },
      {
        label: "Producto",
        key: "producto",
        subKey: "",
        customClass: "",
        type: "producto",
      },
      {
        label: "Monto Capital",
        key: "saldo_capital_total",
        subKey: "",
        customClass: "icon-sort", //icon-sort
        type: "money-pre-sum",
      },
      {
        label: "Portafolio",
        key: "portafolio",
        subKey: "",
        customClass: "icon-sort", //icon-sort
        type: "portafolio",
      },

      {
        label: "",
        key: "_id",
        subKey: "",
        customClass: "btnCartaNoAdeudo",
        type: "buttonCartaNoAdeudo",
      },

      {
        label: "",
        key: "_id",
        subKey: "",
        customClass: "btnAnularExtincion",
        type: "buttonAnularExtincion",
      },
    ];

    let filter: string = "&page=1";

    this.cuentasService.getCuentasExtinguidas(filter).subscribe((data: any) => {
      if (data.msg == "Peticion invalida") {
        sessionStorage.removeItem("token");
        this.route.navigate(["login"], {});
      }

      let cuentasTemp: any[] = [];
      for (let item of data.cuentas.docs) {
        let date1: Date = new Date(item.fecha_vencimiento);
        let date2: Date = new Date();
        item.cliente = item.nombre;
        item.mora = this.difference(date1, date2);

        let montoCapitalTotal = parseFloat(item.saldo_capital.$numberDecimal);
        /*for(let itemCuenta of item.cuentas){
            montoCapitalTotal+=parseFloat(itemCuenta.saldo_capital.$numberDecimal)
            
          }*/
        item.saldo_capital_total = montoCapitalTotal;
        cuentasTemp.push(item);
      }

      this.dataNegociacion = cuentasTemp;
      this.paginationNegociacion.hasNextPage = data.cuentas.hasNextPage;
      this.paginationNegociacion.hasPrevPage = data.cuentas.hasPrevPage;
      this.paginationNegociacion.totalPages = new Array(
        data.cuentas.totalPages
      );
      this.paginationNegociacion.page = data.cuentas.page;
      this.paginadorNegociacion.pagParams = this.paginationNegociacion;

      this.isDataLoaded = true;
    });
  }

  ctaExtinguir: string = "";
  ctaAnular: string = "";
  linkReporte: string = "";
  extinguirCuenta(row: any) {
    this.showModalExtinguir = true;
    this.ctaExtinguir = row.cuenta;
  }

  anularExtincion(row: any) {
    this.ctaAnular = row.cuenta;
    this.showModalAnular = true;
  }

  confirmarExtinguirCuenta() {
    let dataSend: any = {
      cuenta: this.ctaExtinguir,
    };
    this.cuentasService.extinguirCuenta(dataSend).subscribe((data: any) => {
      this.ctaExtinguir = "";
      this.showModalExtinguir = false;
      this.refreshGrid(1);
    });
  }

  confirmarAnularExtincion() {
    let dataSend: any = {
      cuenta: this.ctaAnular,
    };
    this.cuentasService
      .anularExinticionCuenta(dataSend)
      .subscribe((data: any) => {
        this.ctaAnular = "";
        this.showModalAnular = false;
        this.refreshGrid(1);
      });
  }

  difference(date1: any, date2: any) {
    const date1utc = Date.UTC(
      date1.getFullYear(),
      date1.getMonth(),
      date1.getDate()
    );
    const date2utc = Date.UTC(
      date2.getFullYear(),
      date2.getMonth(),
      date2.getDate()
    );
    let day: any = 1000 * 60 * 60 * 24;
    return (date2utc - date1utc) / day;
  }

  getFecHoy = () => {
    let hoy: Date = new Date();

    let fecha: any =
      hoy.getDate() + "/" + (hoy.getMonth() + 1) + "/" + hoy.getFullYear();
    let mes: any = hoy.getMonth() + 1;
    mes = mes.toString().length == 1 ? "0" + mes : mes;
    let dia: any = hoy.getDate();
    dia = dia.toString().length == 1 ? "0" + dia : dia;
    return hoy.getFullYear() + "-" + mes + "-" + dia;
  };

  ngAfterViewInit(): void {}

  edit(row: any) {}

  delete(row: any) {}

  openModal(row: any) {}

  sortItem: string = "desc";
  sortColumn(row: any) {
    if (row.customClass == "icon-sort") {
      //console.log(row)
      if (row.key == "saldo_capital_total") {
        let filter: string =
          "&page=1&sort=" + this.sortItem + "&column_sort=saldo_capital";
        this.refreshSort(filter);
      }

      if (row.key == "cuentas") {
        let filter: string =
          "&page=1&sort=" + this.sortItem + "&column_sort=portafolio";
        this.refreshSort(filter);
      }
    }
  }

  refreshSort(filter: string) {
    this.isDataLoaded = false;
    this.cuentasService.getCuentasExtinguidas(filter).subscribe((data: any) => {
      if (data.msg == "Peticion invalida") {
        sessionStorage.removeItem("token");
        this.route.navigate(["login"], {});
      }

      let cuentasTemp: any[] = [];
      for (let item of data.cuentas.docs) {
        let date1: Date = new Date(item.fecha_vencimiento);
        let date2: Date = new Date();
        item.cliente = item.nombre;
        item.mora = this.difference(date1, date2);

        let montoCapitalTotal = parseFloat(item.saldo_capital.$numberDecimal);
        /*for(let itemCuenta of item.cuentas){
            montoCapitalTotal+=parseFloat(itemCuenta.saldo_capital.$numberDecimal)
            
          }*/
        item.saldo_capital_total = montoCapitalTotal;
        cuentasTemp.push(item);
      }

      this.dataNegociacion = cuentasTemp;
      this.paginationNegociacion.hasNextPage = data.cuentas.hasNextPage;
      this.paginationNegociacion.hasPrevPage = data.cuentas.hasPrevPage;
      this.paginationNegociacion.totalPages = new Array(
        data.cuentas.totalPages
      );
      this.paginationNegociacion.page = data.cuentas.page;
      this.paginadorNegociacion.pagParams = this.paginationNegociacion;
      this.sortItem = this.sortItem == "desc" ? "asc" : "desc";
      this.isDataLoaded = true;
    });
  }

  goTo(row: any) {
    this.route.navigateByUrl(`gestion-cliente/${row.nro_documento}`, {
      replaceUrl: true,
    });
  }

  refreshGrid(page: any) {
    this.isDataLoaded = false;
    this.cuentasService
      .getCuentasExtinguidas("&page=" + page)
      .subscribe((data: any) => {
        let cuentasTemp: any[] = [];
        for (let item of data.cuentas.docs) {
          let date1: Date = new Date(item.fecha_vencimiento);
          let date2: Date = new Date();
          item.cliente = item.nombre;
          item.mora = this.difference(date1, date2);

          let montoCapitalTotal = parseFloat(item.saldo_capital.$numberDecimal);
          /*for(let itemCuenta of item.cuentas){
            montoCapitalTotal+=parseFloat(itemCuenta.saldo_capital.$numberDecimal)
            
          }*/
          item.saldo_capital_total = montoCapitalTotal;
          cuentasTemp.push(item);
        }

        this.dataNegociacion = cuentasTemp;
        this.paginationNegociacion.hasNextPage = data.cuentas.hasNextPage;
        this.paginationNegociacion.hasPrevPage = data.cuentas.hasPrevPage;
        this.paginationNegociacion.totalPages = new Array(
          data.cuentas.totalPages
        );
        this.paginationNegociacion.page = data.cuentas.page;
        this.paginadorNegociacion.pagParams = this.paginationNegociacion;
        this.isDataLoaded = true;
      });
  }

  closeModal() {
    this.showModalExtinguir = false;
    this.showModalAnular = false;
  }

  getReporteExtinguidos() {
    this.reportesService.reporteCuentasExtinguidas().subscribe((data: any) => {
      this.linkReporte = this.baseApi + "reporteExcel?archivo=" + data.archivo;
    });
  }

  filterGrid(filter: any) {
    this.isDataLoaded = false;
    let filterQuery: string = "";
    if (filter.target.id == "nro_documento") {
      filterQuery = "nro_documento=" + filter.target.value;
    }

    if (filter.target.id == "nombre_cliente") {
      filterQuery = "cliente=" + filter.target.value;
    }

    this.cuentasService
      .getCuentasExtinguidas("page=1&" + filterQuery)
      .subscribe((data: any) => {
        let cuentasTemp: any[] = [];
        for (let item of data.cuentas.docs) {
          let date1: Date = new Date(item.fecha_vencimiento);
          let date2: Date = new Date();
          item.cliente = item.nombre;
          item.mora = this.difference(date1, date2);

          let montoCapitalTotal = parseFloat(item.saldo_capital.$numberDecimal);
          /*for(let itemCuenta of item.cuentas){
            montoCapitalTotal+=parseFloat(itemCuenta.saldo_capital.$numberDecimal)
            
          }*/
          item.saldo_capital_total = montoCapitalTotal;
          cuentasTemp.push(item);
        }

        this.dataNegociacion = cuentasTemp;
        this.paginationNegociacion.hasNextPage = data.cuentas.hasNextPage;
        this.paginationNegociacion.hasPrevPage = data.cuentas.hasPrevPage;
        this.paginationNegociacion.totalPages = new Array(
          data.cuentas.totalPages
        );
        this.paginationNegociacion.page = data.cuentas.page;
        this.paginadorNegociacion.pagParams = this.paginationNegociacion;
        this.isDataLoaded = true;
      });
  }

  async generarCartaNoAdeudo(cuenta: any) {
    //NONE, FAST, MEDIUM and SLOW
    let empresa: string = "";
    let ruc: string = "";
    if (cuenta.portafolio == "P07" || cuenta.portafolio == "P08") {
      empresa = "El FONDO NPL BCP 2019-II FONDO DE INVERSION PRIVADO"; //, acreencia originada con el BANCO DE CREDITO DEL PERU.
      ruc = "20604048398";
    } else {
      empresa = "BANCARIZATE S.A.C."; // acreencia originada con el BANCO BBVA CONTINENTAL.
      ruc = "20601302196";
    }

    //FONDO I INDEPENDENCIA el pasado 01-03-2023

    const doc = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a4",
      lineHeight: 1.7,
    });
    var img_logo = new Image();
    if (cuenta.portafolio == "P07" || cuenta.portafolio == "P08") {
      img_logo.src = "assets/images/npl-management.jpg";
      doc.addImage(img_logo, "jpg", 50, 16, 120, 42, undefined, "SLOW");
    } else {
      img_logo.src = "assets/images/logo-bancarizate.png";
      doc.addImage(img_logo, "png", 50, 16, 120, 32, undefined, "SLOW");
    }

    let n: number = 60;

    doc.setFontSize(12);
    //doc.text(`CARTA DE COMUNICACIÓN DE CESION DE DERECHOS  `,135,n)

    var midPage = doc.internal.pageSize.getWidth() / 2;
    doc.setFontSize(14);
    doc.text(`CARTA DE NO ADEUDO :`, midPage, (n = n + 15), {
      align: "center",
    });
    doc.setFontSize(13);
    doc.text(
      `${cuenta.clientes[0].nro_documento} - ${cuenta.cuentas_extinguidas[0].correlativo}`,
      midPage,
      (n = n + 20),
      { align: "center" }
    );

    
    doc.setFontSize(12);
    if (cuenta.portafolio == "P10") {
      doc.text(
        `${empresa} con RUC No ${ruc} en calidad de cesionario de FONDO I INDEPENDENCIA expide la presente constancia, informando que a la fecha el titular, ${cuenta.clientes[0].nombre} con DNI No ${cuenta.clientes[0].nro_documento}, no mantiene saldo deudor con nuestra Empresa por la(s) Obligación(es) Contrato(s) que a continuación se detalla(n).`,
        50,
        (n = n + 30),
        { maxWidth: 490, align: "justify" }
      );
    }else if (cuenta.portafolio == "P11") {
      doc.text(
        `${empresa} con RUC No ${ruc} en calidad de cesionario de CAJA MUNICIPAL DE AHORRO Y CREDITO DE AREQUIPA , identificada con RUC N° 20100209641 expide la presente constancia, informando que a la fecha el titular, ${cuenta.clientes[0].nombre} con DNI No ${cuenta.clientes[0].nro_documento}, no mantiene saldo deudor con nuestra Empresa por la(s) Obligación(es) Contrato(s) que a continuación se detalla(n).`,
        50,
        (n = n + 30),
        { maxWidth: 490, align: "justify" }
      );
    } else {
      doc.text(
        `${empresa} con RUC No ${ruc} en calidad de cesionario de FOUR CAPITAL S.A.C expide la presente constancia, informando que a la fecha el titular, ${cuenta.clientes[0].nombre} con DNI No ${cuenta.clientes[0].nro_documento}, no mantiene saldo deudor con nuestra Empresa por la(s) Obligación(es) Contrato(s) que a continuación se detalla(n).`,
        50,
        (n = n + 30),
        { maxWidth: 490, align: "justify" }
      );
    }

    let dataCuentasDoc = [];

    if (cuenta.portafolio == "P07" || cuenta.portafolio == "P08") {
      n = n + 20;
    }

    if (cuenta.portafolio == "P11") {
      n = n + 28;
    }

    let cuentasTemp = [];
    for (let cta of cuenta.cuentas_extinguidas) {
      if (!cuentasTemp.includes(cta.cuenta)) {
        dataCuentasDoc.push([cta.producto, cta.cuenta, "CERO", "NO ADEUDO"]);
        cuentasTemp.push(cta.cuenta);
      }
    }

    //dataCuentasDoc.push([cuenta.producto,cuenta.cuenta, "CERO","NO ADEUDO"])
    doc.autoTable({
      head: [["PRODUCTO", "# OPERACIÓN", "DEUDA A LA FECHA", "SITUACIÓN"]],
      body: dataCuentasDoc,
      margin: { top: (n = n + 85) },
      theme: "plain",
      headStyles: {
        fillColor: [222, 226, 230],
        textColor: [0, 0, 0],
        lineWidth: 1,
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineWidth: 1,
      },
      columnStyles: { styles: { halign: "center" } },
      styles: { halign: "center" },
    });

    for (let x = 1; x <= cuentasTemp.length; ++x) {
      n = n + 20;
    }

    

    if (cuenta.portafolio == "P10") {
      doc.text(
        `Esta(s) obligación(es) contrato(s) fue (ron) en cesiones sucesivas los derechos y acciones por FONDO I INDEPENDENCIA el pasado 01-03-2023.`,
        50,
        (n = n + 70),
        { maxWidth: 490, align: "justify" }
      );
    }else if (cuenta.portafolio == "P11") {
      doc.text(
        `Este documento se emite en atención a su solicitud para los fines que estime pertinentes, por lo que no asumimos ni asumiremos responsabilidad por los usos y/o destino que usted y/o terceros pudieran darle.`,
        50,
        (n = n + 90),
        { maxWidth: 490, align: "justify" }
      );
    } else {
      doc.text(
        `Esta(s) obligación(es) contrato(s) fue (ron) en cesiones sucesivas los derechos y acciones por FOUR CAPITAL SAC el pasado 10 de octubre 2020.`,
        50,
        (n = n + 70),
        { maxWidth: 490, align: "justify" }
      );
    }

    if(cuenta.portafolio == "P11"){
      
      doc.text(
        `La presente constancia se expide sin perjuicio de la observancia de los plazos y demás requisitos que sean exigidos para eliminar registros, antecedentes y/o levantar sanciones que pudieran habérsele aplicado por morosidad y/o protesto de títulos valores.`,
        50,
        (n = n + 70),
        { maxWidth: 490, align: "justify" }
      );
    }else{
      doc.text(
        `Así mismo, certificamos que a la fecha esta obligación ha sido cancelada por el Importe de PAGO TOTAL y en consecuencia ya no mantiene a la fecha saldo deudor por la(s) obligación(es) ante(s) citada(s).`,
        50,
        (n = n + 50),
        { maxWidth: 490, align: "justify" }
      );
  
      doc.text(
        `Este documento se emite en atención a su solicitud para los fines que estime pertinentes, por lo que no asumimos ni asumiremos responsabilidad por los usos y/o destino que usted y/o terceros pudieran darle.`,
        50,
        (n = n + 70),
        { maxWidth: 490, align: "justify" }
      );
  
      doc.text(
        `La presente constancia se expide sin perjuicio de la observancia de los plazos y demás requisitos que sean exigidos para eliminar registros, antecedentes y/o levantar sanciones que pudieran habérsele aplicado por morosidad y/o protesto de títulos valores.`,
        50,
        (n = n + 70),
        { maxWidth: 490, align: "justify" }
      );
    }

    if(cuenta.portafolio == "P11"){
      
      doc.text(
        `Santiago de Surco, ${
          this.fechaISO[2]
        } de ${getMonth(this.fechaISO[1])} del ${this.fechaISO[3]}`,
        290,
        (n = n + 80)
      );
    }else{
      doc.text(
        `Santiago de Surco, el ${this.getDiaNombre(this.fechaISO[0])} ${
          this.fechaISO[2]
        } de ${getMonth(this.fechaISO[1])} del ${this.fechaISO[3]}`,
        250,
        (n = n + 80)
      );
    }

    

    doc.text(`Atentamente`, 50, (n = n + 60));
    var img = new Image();
    img.src = "assets/images/firma-npl.jpg";
    doc.addImage(img, "jpg", 50, (n = n + 10), 100, 42, undefined, "SLOW");

    //var img_ = new Image()

    if (cuenta.portafolio == "P07" || cuenta.portafolio == "P08") {
      //img_.src = 'assets/images/qr-npl.png'
      //doc.addImage(img_, 'png', 430, (n-30), 120, 120,undefined,'SLOW')
      doc.text(
        `FONDO NPL BCP 2019-II FONDO DE INVERSIÓN PRIVADO representado por NPL MANAGEMENT Sociedad Gestora de Fondos de Inversión S.A.C. quien a su vez actúa representada por Alvaro Rivas Tavera`,
        50,
        (n = n + 50),
        { maxWidth: 350, align: "justify" }
      );
    } else {
      //img_.src = 'assets/images/qr-bancarizate.png'
      //doc.addImage(img_, 'png', 460, (n-40), 120, 120,undefined,'SLOW')
      doc.text(`Alvaro Rivas`, 50, (n = n + 55));
      doc.text(`Gerente General`, 50, (n = n + 15));
    }

    var img_footer = new Image();
    if (cuenta.portafolio == "P07" || cuenta.portafolio == "P08") {
      img_footer.src = "assets/images/footer-npl-2.png";
      doc.addImage(img_footer, "png", 140, 780, 300, 60, undefined, "SLOW");
    } else {
      img_footer.src = "assets/images/pie-pagina-bancarizate.png";
      doc.addImage(img_footer, "png", 140, 785, 340, 50, undefined, "SLOW");
    }

    doc.save(
      `${new Date().toISOString()}_carta_no_adeudo_${
        cuenta.clientes[0].nro_documento
      }.pdf`
    );
  }

  getDiaNombre(fec_day: any) {
    let dia: string = "";

    if (fec_day == "Sun") {
      dia = "domingo";
    }

    if (fec_day == "Mon") {
      dia = "lunes";
    }

    if (fec_day == "Tue") {
      dia = "martes";
    }

    if (fec_day == "Wed") {
      dia = "miércoles";
    }

    if (fec_day == "Thu") {
      dia = "jueves";
    }

    if (fec_day == "Fri") {
      dia = "viernes";
    }

    if (fec_day == "Sat") {
      dia = "sábado";
    }

    return dia;
  }
}
